import { render, staticRenderFns } from "./ShoppingCartComponent.vue?vue&type=template&id=980fd550&"
import script from "./ShoppingCartComponent.vue?vue&type=script&lang=ts&"
export * from "./ShoppingCartComponent.vue?vue&type=script&lang=ts&"
import style0 from "./ShoppingCartComponent.vue?vue&type=style&index=0&id=980fd550&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports